<template>
  <div class="background-gray has-border pa-4">
    <v-form ref="form">
      <div v-for="schedule in time" :key="schedule.id">
        <div class="input-wrapper mb-6">
          <div style="width: 300px" class="pr-3">
            <BaseDropdown
              label="Ngày trong tuần"
              placeholder="Chọn ngày trong tuần"
              :items="DAYS_IN_WEEK.map((x) => ({ ...x, title: x.title }))"
              v-model="schedule.day"
              item-text="title"
              item-value="value"
              hide-details
            />
          </div>
          <div style="width: 300px" class="pr-3">
            <BaseInput
              :rules="[$rules.required, $rules.time, $rules.rangeTime(schedule.endTime)]"
              v-model="schedule.startTime"
              append-icon="mdi-clock-outline"
              label="Giờ bắt đầu"
              placeholder="Chọn giờ bắt đầu"
              hide-details
            />
          </div>
          <div style="width: 300px" class="pr-3">
            <BaseInput
              :rules="[$rules.required, $rules.time]"
              v-model="schedule.endTime"
              append-icon="mdi-clock-outline"
              label="Giờ kết thúc"
              placeholder="Chọn giờ kết thúc"
              hide-details
            />
          </div>
          <AutocompleteClassroom
            v-model="schedule.classroom"
            clear-icon="mdi-close"
            label="Phòng học"
            outlined
            dense
          />
          <v-btn @click="$emit('delete', schedule)" icon color="red">
            <v-icon>mdi-delete-forever</v-icon>
          </v-btn>
        </div>
      </div>
    </v-form>
    <div>
      <v-divider class="mb-4" />
      <BaseButton icon="mdi-plus" isButtonText text="Thêm lịch" @click="$emit('create')" depressed class="px-0" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.input-wrapper {
  display: flex;
}
</style>
<script>
import BaseButton from '../../../components/basic/BaseButton.vue'
import BaseDropdown from '../../../components/basic/BaseDropdown.vue'
import BaseInput from '../../../components/basic/BaseInput.vue'
import AutocompleteClassroom from '@/components/basic/input/AutocompleteClassroom.vue'
export default {
  components: {
    BaseDropdown,
    BaseInput,
    BaseButton,
    AutocompleteClassroom,
  },
  props: {
    schedules: Array,
    isAllInputDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      time: [],
      DAYS_IN_WEEK: [
        {
          title: 'Thứ hai',
          value: 'monday',
        },
        {
          title: 'Thứ ba',
          value: 'tuesday',
        },
        {
          title: 'Thứ tư',
          value: 'wednesday',
        },
        {
          title: 'Thứ năm',
          value: 'thursday',
        },
        {
          title: 'Thứ sáu',
          value: 'friday',
        },
        {
          title: 'Thứ bảy',
          value: 'saturday',
        },
        {
          title: 'Chủ nhật',
          value: 'sunday',
        },
      ],
    }
  },
  watch: {
    schedules: {
      handler(val) {
        if (val) {
          this.time = val
        }
      },
      immediate: true,
      deep: true,
    },
    time: {
      handler(val) {
        if (val) {
          setTimeout(() => this.$refs.form.validate(), 200)
        }
      },
      deep: true,
    },
  },
}
</script>
